// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"112":"e7e90f19","563":"67e99538"}[chunkId] + ".chunk.css";
};